@import "../../styles/constants.scss";

.popup-dialog-container {
  position: relative;
  z-index: 999999999999;
  .popup-dialog-overlay {
    background: var(--modal-overlay-bg);
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .modal-dialog-content {
    max-width: 800px;
  }

  .popup-dialog-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    &.warning {
      width: 575px;
      .popup-dialog-text {
        font-size: var(--font-size-s);
      }
    }
  }

  .popup-dialog-content {
    background: var(--modal-background-color);
    border: 1px solid #ccc;
    min-height: 100px;
    flex-flow: column nowrap;
    justify-content: space-between;
    display: flex;
    border-radius: var(--border-radius-s-m);
    flex-flow: column nowrap;
    min-width: 400px;
    padding: 0;
  }

  .confirmation-dialog-header {
    display: flex;
    justify-content: space-between;
    padding: 15px 0;
    font-weight: 600;
    color: var(--text-color-main);
    border-bottom: 1px solid var(--border-color);
    margin: 0 var(--padding-l);
    height: 80px;
    align-items: center;

    .confirmation-dialog-title {
      color: var(--text-color-main);
      font-size: var(--font-size-l);
      font-weight: 500;

      [class^="seem-icon"] {
        margin-right: 10px;
      }
    }
  }
  .confirmation-dialog-character-container {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    height: 160px;
    padding-top: var(--spacing-5);

    &.warning {
      padding: 0px var(--spacing-7) 0px 25px;
      margin-top: var(--spacing-5);
      min-height: 88px;
      max-height: 300px;
      height: auto;
      overflow: auto;
    }
  }

  .popup-dialog-text {
    font-size: var(--font-size-m);
    line-height: 1.4;
    text-align: center;
    color: var(--text-color-main);
    max-height: calc(100vh - 440px);

    &.has-padding {
      margin: 10px var(--spacing-5) 0;
      padding: 5px var(--spacing-5);
    }
  }
}
.popup-dialog-buttons {
  margin-top: 34px;
  margin-bottom: var(--spacing-6);
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  padding-left: var(--spacing-5);
  padding-right: var(--spacing-5);
  .form-button-wrap {
    margin-right: 15px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.confirmation-dialog {
  .modal-text {
    text-align: center;
    word-wrap: break-word;
    white-space: pre-wrap;
    @include b2-typography();
  }
  .modal-buttons-container {
    justify-content: center;
  }
  &.error {
    .modal-dialog-content {
      min-width: 460px;
      background-color: var(--main-background-color);
    }
    .modal-text {
      text-align: center;
    }
  }
  &.is-align-left .modal-text {
    text-align: left;
  }
}
@media screen and (max-height: 470px) {
  .popup-dialog-container .confirmation-dialog-character-container {
    display: none;
  }
  .popup-dialog-container .popup-dialog-text {
    max-height: calc(100vh - 220px);
  }
}
